import "@/App.css";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";
import ScrollToTop from "./components/ScrollToTop";
import { OrderProvider } from "./context/OrderContext";
import Home from "./pages/Home";
import LocationPage from "./components/LocationPage";
import GiftCards from "./components/GiftCards";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ScrollToTop />
        <OrderProvider>
          <div className="App grain-overlay" data-testid="app-root">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/coffee-shop/:slug" element={<LocationPage />} />
              <Route path="/gift-cards" element={<GiftCards />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <FloatingCTA />
          </div>
        </OrderProvider>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
